import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#05080D]" data-testid="auth-loading">
        <Loader2 className="h-7 w-7 animate-spin text-[#4F8CFF]" />
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}
